import * as S from "./styles";
import P from "prop-types";

import { useHistory } from "react-router-dom";

export function Slide({ img, imgAlt, index }) {
  const history = useHistory();

  function handleClick() {
    history.push({
      pathname: "/paineis",
      state: { index: index },
    });
  }

  return (
    <S.Container onClick={() => handleClick()}>
      <img src={img} alt={imgAlt} />
    </S.Container>
  );
}

Slide.propTypes = {
  imgAlt: P.string.isRequired,
  index: P.number.isRequired,
};
